import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useAdminMemberWithdrawDetails, useAdminLoans, useUpdateMemberKyc, useUpdateMemberStatus, useKyc } from "../../hooks/useAdmin";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";
import Avatar from "../../components/ui/Avatar";
import StatCard from "../../components/ui/StatCard";

const fmt = (n:number) => new Intl.NumberFormat("en-NG",{style:"currency",currency:"NGN", currencyDisplay:"symbol",maximumFractionDigits:0}).format(n);
const fmtDate = (d:string) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";

export default function MemberWithdrawalDetailsPage() {
  const { id }   = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const { data: m }              = useAdminMemberWithdrawDetails(id!)    as any;
  const { data: loans = [] }     = useAdminLoans()        as any;
  //const {data: kyc} = useKyc(id!) as any;

  //const updateKyc    = useUpdateMemberKyc();
  //const updateStatus = useUpdateMemberStatus();

  //const [docPath, setDocPath] = useState("");
  //const [reason, setReason] = useState("");

  if (!m) return <div className="p-8 text-center text-slate-400">Loading…</div>;

  //const memberLoans = loans.filter((l: any) => l.borrower_id === id);
  //const kycColor  = (k:string) => k==="verified"?"emerald":k==="reviewing"?"amber":"red";
  const statColor = (s:string) => s==="active"?"emerald":s==="suspended"?"red":"amber";

  return (
    <div>
      <Button variant="outline" size="sm" onClick={() => navigate("/admin/withdrawals")} className="mb-5">← Back</Button>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 mb-4">
        {/* Profile */}
        <Card className="lg:col-span-2">
          <div className="flex gap-4 items-center mb-5">
            <Avatar initials={`${m.first_name?.[0]}${m.last_name?.[0]}`} size={56}/>
            <div>
              <h2 className="text-lg font-medium text-slate-800">{m.first_name} {m.last_name}</h2>
              <p className="text-sm text-slate-500 mb-1.5">{m.email} | {m.phone}</p>
              <Badge label={m.status} color={statColor(m.status) as any}/>
            </div>
          </div>
          {[
            {label:"Member since", value:fmtDate(m.created_at)},
            {label:"KYC status",   value:m.kyc_status},
            {label:"Total Sum",      value:fmt(m.balance||0)},
            {label:"One-off Charge", value:fmt(m.charges || 0)},
            {label:"Balance",      value:fmt((m.balance - m.charges) ||0)},
            {label:"Locked Amount",       value:fmt(m.locked_amount||0)},
            {label:"Withdrawal Status",       value:m.withdrawal_status},
            {label:"Withdrawal Amount",       value:fmt(m.amount||0)},
            {label:"Deposit To",       value:m.bank+' ... '+m.account_name+' ... '+m.account_no},
            // {label:"Account Name",       value:m.account_name},
            // {label:"Account Number",       value:m.account_no},
          ].map(r => (
            ["Withdrawal Status","Withdrawal Amount","Deposit To","Account Name","Account Number"].includes(r.label)?
            <div key={r.label} className="flex justify-between py-2.5 border-t border-slate-100" style={{border:"solid 1px green", borderRadius:"7px", paddingRight:"3px", marginTop:"2px"}}>
              <span className="text-sm text-slate-500">{r.label}</span>
              <span className="text-sm font-medium text-slate-800">{r.value}</span>
            </div>
            :
            <div key={r.label} className="flex justify-between py-2.5 border-t border-slate-100">
              <span className="text-sm text-slate-500">{r.label}</span>
              <span className="text-sm font-medium text-slate-800">{r.value}</span>
            </div>
          ))}          
        </Card>        
      </div>
    </div>
  );
}
